import { PaginationOptions } from '@jgereg/paginated';
import { useCallback } from 'react';
import { usePagination } from '../../hooks';
import { useTableFilters } from '../../hooks/useTableFilters';
import { FilterSortPaginated } from '../accidents/hooks/useAccidentsFilter';
import { AccidentSourceValueItem } from '../types/accident';

export interface RegistryFiltersType {
  search: string;
}

export const useRegistryFilter = (
  data: AccidentSourceValueItem[],
  {
    defaultPaginationState = { page: 1, pageSize: 10 }
  }: Partial<{
    defaultPaginationState: PaginationOptions;
  }> = {}
): Omit<FilterSortPaginated<AccidentSourceValueItem, any>, 'sort'> => {
  const {
    data: filteredData,
    filters,
    setFilter: setRegistryFilter
  } = useTableFilters<AccidentSourceValueItem, RegistryFiltersType>(
    data,
    [
      (item, { search }) => {
        const matchesSearch =
          search !== ''
            ? [item.name, item.tradeName, item.address].some((field) =>
                field?.toLowerCase().includes(search.toLowerCase())
              )
            : true;

        return matchesSearch;
      }
    ],
    {
      defaultFilterState: {
        search: ''
      }
    }
  );

  const { items, pagination, resetPagination, setPage } = usePagination(filteredData, defaultPaginationState);

  const handleFilterChange = useCallback(
    (filters: RegistryFiltersType) => {
      resetPagination();
      setRegistryFilter(filters);
    },
    [resetPagination, setRegistryFilter]
  );

  return {
    items,
    filters: {
      filters,
      setFilters: handleFilterChange
    },
    pagination: {
      ...pagination,
      setPage
    }
  };
};
